<script>
	import { Router } from 'svelte-router-spa'
	import { routes } from './routes.js';
	import Alerts from '/core/components/alerts/Alerts.svelte';
        import Navbar from '/public/components/layout/Navbar.svelte';
	import Footer from '/core/components/layout/Footer.svelte';
        import LoaderIndicator from '/core/components/layout/LoaderIndicator.svelte';

</script>

<main>
    <LoaderIndicator/>

    <div class="container-fluid page-content-wrapper">

        <Alerts/>

        <Navbar/>

        <div class='page-router-wrapper'>

            <Router {routes} />

        </div>

        <Footer/>

    </div>

</main>

<style>
    .page-content-wrapper {
        margin: 0;
        padding: 0;
    }
    .page-router-wrapper {
        padding: 0em 1em;
    }
</style>
